
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-esndbs",
"minContentWidth": "--awsui-min-content-width-esndbs",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-esndbs",
"contentGapLeft": "--awsui-content-gap-left-esndbs",
"contentGapRight": "--awsui-content-gap-right-esndbs",
"contentHeight": "--awsui-content-height-esndbs",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-esndbs",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-esndbs",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-esndbs",
"defaultMaxContentWidth": "--awsui-default-max-content-width-esndbs",
"defaultMinContentWidth": "--awsui-default-min-content-width-esndbs",
"drawerSize": "--awsui-drawer-size-esndbs",
"drawerMinSize": "--awsui-drawer-min-size-esndbs",
"bottomDrawerSize": "--awsui-bottom-drawer-size-esndbs",
"footerHeight": "--awsui-footer-height-esndbs",
"headerGap": "--awsui-header-gap-esndbs",
"headerHeight": "--awsui-header-height-esndbs",
"layoutWidth": "--awsui-layout-width-esndbs",
"mainGap": "--awsui-main-gap-esndbs",
"mainOffsetLeft": "--awsui-main-offset-left-esndbs",
"mainTemplateRows": "--awsui-main-template-rows-esndbs",
"mobileBarHeight": "--awsui-mobile-bar-height-esndbs",
"notificationsHeight": "--awsui-notifications-height-esndbs",
"offsetTop": "--awsui-offset-top-esndbs",
"overlapHeight": "--awsui-overlap-height-esndbs",
"navigationWidth": "--awsui-navigation-width-esndbs",
"navigationCollapsedWidth": "--awsui-navigation-collapsed-width-esndbs",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-esndbs",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-esndbs",
"splitPanelHeight": "--awsui-split-panel-height-esndbs",
"splitPanelMinWidth": "--awsui-split-panel-min-width-esndbs",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-esndbs",
"toolsMaxWidth": "--awsui-tools-max-width-esndbs",
"toolsWidth": "--awsui-tools-width-esndbs",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-esndbs",
"contentScrollMargin": "--awsui-content-scroll-margin-esndbs",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-esndbs",
"flashbarStackIndex": "--awsui-flashbar-stack-index-esndbs",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-esndbs",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-esndbs",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-esndbs",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-esndbs",
"dropdownDefaultMinWidth": "--awsui-dropdown-default-min-width-esndbs",
"dropdownContentBorderColor": "--awsui-dropdown-content-border-color-esndbs",
"dropdownContentBorderWidth": "--awsui-dropdown-content-border-width-esndbs",
"dropdownContentBorderRadius": "--awsui-dropdown-content-border-radius-esndbs",
"modalCustomWidth": "--awsui-modal-custom-width-esndbs",
"modalCustomHeight": "--awsui-modal-custom-height-esndbs",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-esndbs",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-esndbs",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-esndbs",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-esndbs",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-esndbs",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-esndbs",
"sliderLabelCount": "--awsui-slider-label-count-esndbs",
"sliderTickCount": "--awsui-slider-tick-count-esndbs",
"sliderReferenceColumn": "--awsui-slider-reference-column-esndbs",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-esndbs",
"sliderMaxStart": "--awsui-slider-max-start-esndbs",
"sliderMinEnd": "--awsui-slider-min-end-esndbs",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-esndbs",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-esndbs",
"togglesLeftWidth": "--awsui-toggles-left-width-esndbs",
"togglesRightWidth": "--awsui-toggles-right-width-esndbs",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-esndbs",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-esndbs",
"dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-esndbs",
"dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-esndbs",
"styleBackgroundActive": "--awsui-style-background-active-esndbs",
"styleBackgroundDefault": "--awsui-style-background-default-esndbs",
"styleBackgroundDisabled": "--awsui-style-background-disabled-esndbs",
"styleBackgroundHover": "--awsui-style-background-hover-esndbs",
"styleBorderColorActive": "--awsui-style-border-color-active-esndbs",
"styleBorderColorDefault": "--awsui-style-border-color-default-esndbs",
"styleBorderColorDisabled": "--awsui-style-border-color-disabled-esndbs",
"styleBorderColorHover": "--awsui-style-border-color-hover-esndbs",
"styleColorActive": "--awsui-style-color-active-esndbs",
"styleColorDefault": "--awsui-style-color-default-esndbs",
"styleColorDisabled": "--awsui-style-color-disabled-esndbs",
"styleColorHover": "--awsui-style-color-hover-esndbs",
"styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-esndbs",
"styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-esndbs",
"styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-esndbs",
"styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-esndbs",
"styleBoxShadowActive": "--awsui-style-box-shadow-active-esndbs",
"styleBoxShadowDefault": "--awsui-style-box-shadow-default-esndbs",
"styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-esndbs",
"styleBoxShadowHover": "--awsui-style-box-shadow-hover-esndbs",
"styleBackgroundReadonly": "--awsui-style-background-readonly-esndbs",
"styleBorderColorReadonly": "--awsui-style-border-color-readonly-esndbs",
"styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-esndbs",
"styleColorReadonly": "--awsui-style-color-readonly-esndbs",
"styleBackgroundFocus": "--awsui-style-background-focus-esndbs",
"styleBorderColorFocus": "--awsui-style-border-color-focus-esndbs",
"styleBoxShadowFocus": "--awsui-style-box-shadow-focus-esndbs",
"styleColorFocus": "--awsui-style-color-focus-esndbs",
"stylePlaceholderColor": "--awsui-style-placeholder-color-esndbs",
"stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-esndbs",
"stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-esndbs",
"stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-esndbs",
"styleTabsActiveIndicatorColor": "--awsui-style-tabs-active-indicator-color-esndbs",
"styleTabsActiveIndicatorWidth": "--awsui-style-tabs-active-indicator-width-esndbs",
"styleTabsActiveIndicatorBorderRadius": "--awsui-style-tabs-active-indicator-border-radius-esndbs",
"styleTabsSeparatorColor": "--awsui-style-tabs-separator-color-esndbs",
"styleTabsSeparatorWidth": "--awsui-style-tabs-separator-width-esndbs",
"alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-esndbs",
"alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-esndbs",
"alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-esndbs",
"alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-esndbs",
"alertIconColor": "--awsui-alert-icon-color-esndbs",
"promptInputStyleBackgroundDefault": "--awsui-prompt-input-style-background-default-esndbs",
"promptInputStyleBackgroundDisabled": "--awsui-prompt-input-style-background-disabled-esndbs",
"promptInputStyleBackgroundFocus": "--awsui-prompt-input-style-background-focus-esndbs",
"promptInputStyleBackgroundHover": "--awsui-prompt-input-style-background-hover-esndbs",
"promptInputStyleBackgroundReadonly": "--awsui-prompt-input-style-background-readonly-esndbs",
"promptInputStyleBorderColorDefault": "--awsui-prompt-input-style-border-color-default-esndbs",
"promptInputStyleBorderColorDisabled": "--awsui-prompt-input-style-border-color-disabled-esndbs",
"promptInputStyleBorderColorFocus": "--awsui-prompt-input-style-border-color-focus-esndbs",
"promptInputStyleBorderColorHover": "--awsui-prompt-input-style-border-color-hover-esndbs",
"promptInputStyleBorderColorReadonly": "--awsui-prompt-input-style-border-color-readonly-esndbs",
"promptInputStyleBoxShadowDefault": "--awsui-prompt-input-style-box-shadow-default-esndbs",
"promptInputStyleBoxShadowDisabled": "--awsui-prompt-input-style-box-shadow-disabled-esndbs",
"promptInputStyleBoxShadowFocus": "--awsui-prompt-input-style-box-shadow-focus-esndbs",
"promptInputStyleBoxShadowHover": "--awsui-prompt-input-style-box-shadow-hover-esndbs",
"promptInputStyleBoxShadowReadonly": "--awsui-prompt-input-style-box-shadow-readonly-esndbs",
"promptInputStyleColorDefault": "--awsui-prompt-input-style-color-default-esndbs",
"promptInputStyleColorDisabled": "--awsui-prompt-input-style-color-disabled-esndbs",
"promptInputStyleColorFocus": "--awsui-prompt-input-style-color-focus-esndbs",
"promptInputStyleColorHover": "--awsui-prompt-input-style-color-hover-esndbs",
"promptInputStyleColorReadonly": "--awsui-prompt-input-style-color-readonly-esndbs",
"promptInputStylePlaceholderColor": "--awsui-prompt-input-style-placeholder-color-esndbs",
"promptInputStylePlaceholderFontSize": "--awsui-prompt-input-style-placeholder-font-size-esndbs",
"promptInputStylePlaceholderFontStyle": "--awsui-prompt-input-style-placeholder-font-style-esndbs",
"promptInputStylePlaceholderFontWeight": "--awsui-prompt-input-style-placeholder-font-weight-esndbs",
"promptInputMenuStyleBackgroundColor": "--awsui-prompt-input-menu-style-background-color-esndbs",
"promptInputMenuStyleBorderColor": "--awsui-prompt-input-menu-style-border-color-esndbs",
"promptInputMenuStyleBorderRadius": "--awsui-prompt-input-menu-style-border-radius-esndbs",
"promptInputMenuStyleBorderWidth": "--awsui-prompt-input-menu-style-border-width-esndbs",
"optionBackgroundDefault": "--awsui-option-background-default-esndbs",
"optionBackgroundHighlighted": "--awsui-option-background-highlighted-esndbs",
"optionBackgroundSelected": "--awsui-option-background-selected-esndbs",
"optionColorDefault": "--awsui-option-color-default-esndbs",
"optionColorHighlighted": "--awsui-option-color-highlighted-esndbs",
"optionColorDisabled": "--awsui-option-color-disabled-esndbs",
"optionGroupLabelColor": "--awsui-option-group-label-color-esndbs",
"optionFilterMatchBackground": "--awsui-option-filter-match-background-esndbs",
"optionFilterMatchColor": "--awsui-option-filter-match-color-esndbs",
"progressBarBackgroundColor": "--awsui-progress-bar-background-color-esndbs",
"progressBarBorderRadius": "--awsui-progress-bar-border-radius-esndbs",
"progressBarHeight": "--awsui-progress-bar-height-esndbs",
"progressValueBackgroundColor": "--awsui-progress-value-background-color-esndbs",
"styleSliderTrackBackgroundColor": "--awsui-style-slider-track-background-color-esndbs",
"styleSliderRangeBackgroundDefault": "--awsui-style-slider-range-background-default-esndbs",
"styleSliderRangeBackgroundActive": "--awsui-style-slider-range-background-active-esndbs",
"styleSliderHandleBackgroundDefault": "--awsui-style-slider-handle-background-default-esndbs",
"styleSliderHandleBackgroundHover": "--awsui-style-slider-handle-background-hover-esndbs",
"styleSliderHandleBackgroundActive": "--awsui-style-slider-handle-background-active-esndbs",
"styleSliderHandleBorderRadius": "--awsui-style-slider-handle-border-radius-esndbs",
"tokenStyleBackgroundDefault": "--awsui-token-style-background-default-esndbs",
"tokenStyleBackgroundDisabled": "--awsui-token-style-background-disabled-esndbs",
"tokenStyleBackgroundReadOnly": "--awsui-token-style-background-read-only-esndbs",
"tokenStyleBorderColorDefault": "--awsui-token-style-border-color-default-esndbs",
"tokenStyleBorderColorDisabled": "--awsui-token-style-border-color-disabled-esndbs",
"tokenStyleBorderColorReadOnly": "--awsui-token-style-border-color-read-only-esndbs",
"tokenStyleDismissColorDefault": "--awsui-token-style-dismiss-color-default-esndbs",
"tokenStyleDismissColorDisabled": "--awsui-token-style-dismiss-color-disabled-esndbs",
"tokenStyleDismissColorHover": "--awsui-token-style-dismiss-color-hover-esndbs",
"tokenStyleDismissColorReadOnly": "--awsui-token-style-dismiss-color-read-only-esndbs",
"styleItemCardBackgroundDefault": "--awsui-style-item-card-background-default-esndbs",
"styleItemCardBorderColorDefault": "--awsui-style-item-card-border-color-default-esndbs",
"styleItemCardBorderRadius": "--awsui-style-item-card-border-radius-esndbs",
"styleItemCardBorderWidthDefault": "--awsui-style-item-card-border-width-default-esndbs",
"styleItemCardBoxShadowDefault": "--awsui-style-item-card-box-shadow-default-esndbs",
      };
      export default customCSSPropertiesMap;
    